import React from 'react';
import './styles';

const MIN = 0;

function Count(props) {
  const parsed = parseInt(props.value, 10);
  const current = isNaN(parsed) ? MIN : parsed;

  const step = (by: number) => {
    props.onChange(String(Math.max(MIN, current + by)));
  };

  return (
    <span className="editor__count" data-cy="count">
      <button
        type="button"
        className="editor__count__step"
        data-cy="count-decrement"
        aria-label={`Decrease ${props.label}`}
        disabled={props.disabled}
        onClick={() => step(-1)}
      >
        &minus;
      </button>

      <input
        className="editor__count__value"
        data-cy="count-input"
        type="number"
        min={MIN}
        aria-label={props.label}
        placeholder="Qty"
        disabled={props.disabled}
        value={props.value === null || props.value === undefined ? '' : props.value}
        onChange={(e) => props.onChange(e.target.value)}
      />

      <button
        type="button"
        className="editor__count__step"
        data-cy="count-increment"
        aria-label={`Increase ${props.label}`}
        disabled={props.disabled}
        onClick={() => step(1)}
      >
        +
      </button>
    </span>
  );
}

export default Count;
